import { render } from "./Button.vue?vue&type=template&id=6b66efc7&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=6b66efc7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b66efc7"],['__file',"src/components/mdbvue/Components/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b66efc7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b66efc7', __exports__)) {
    api.reload('6b66efc7', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=6b66efc7&scoped=true", () => {
    api.rerender('6b66efc7', render)
  })

}


export default __exports__